import React, { Dispatch, FC } from 'react';

import { ColumnHeader } from './column-header';
import { IColumnSortingInfo, IHeaderGroup } from 'types/table';

import styles from './styles.module.css';

interface IHeaderProps {
  headerGroups: IHeaderGroup[];
  columnsSorting?: IColumnSortingInfo[];
  sortColumnData?: Dispatch<IColumnSortingInfo>;
}

export const Header: FC<IHeaderProps> = ({ headerGroups, ...rest }) => (
  <div className={styles.header} style={{ width: '100%' }}>
    {headerGroups.map((headerGroup) => (
      <div {...headerGroup.getHeaderGroupProps()} className={styles.tr}>
        {headerGroup.headers.map((column) => (
          <ColumnHeader key={column.id} column={column} {...rest} />
        ))}
      </div>
    ))}
  </div>
);
